import { useState } from "react";
import { FiPlus, FiMinus } from "react-icons/fi";

const QuantitySelector = ({ quantity: initialQuantity = 1 }) => {
  const [quantity, setQuantity] = useState(initialQuantity);

  const handleDecrease = () => {
    if (quantity > 1) setQuantity((prev) => prev - 1);
  };

  const handleIncrease = () => {
    setQuantity((prev) => prev + 1);
  };

  return (
    <div className="flex items-center gap-2 bg-red-100 px-3 py-1 rounded-full">
      <button onClick={handleDecrease} className="text-red-600">
        <FiMinus />
      </button>
      <span className="font-semibold text-red-700">{quantity}</span>
      <button onClick={handleIncrease} className="text-red-600">
        <FiPlus />
      </button>
    </div>
  );
};

const CartItem = ({ item }) => (
  <div className="bg-white p-4 rounded-xl shadow">
    <div className="flex justify-between items-center">
      <img
        src={item.image}
        alt={item.title}
        className="w-16 h-16 rounded-lg object-cover"
      />
      <div className="flex-1 px-4">
        <h4 className="font-semibold text-sm">{item.title}</h4>
        <p className="text-xs text-gray-500">{item.description}</p>
        <p className="text-red-600 font-bold text-sm">${item.price}</p>
      </div>
      <QuantitySelector quantity={item.quantity} />
    </div>
  </div>
);

const CartList = () => {
  const cartItems = [
    {
      id: 1,
      title: "Salad Tuna",
      description: "Spicy chicken, beef",
      price: 10.99,
      quantity: 1,
      image: "https://source.unsplash.com/80x80/?salad",
    },
    {
      id: 2,
      title: "Grilled Chicken",
      description: "With herbs and veggies",
      price: 12.49,
      quantity: 2,
      image: "https://source.unsplash.com/80x80/?grilled-chicken",
    },
  ];

  return (
    <div className="p-4 bg-gray-50 min-h-screen space-y-4 mx-auto">
      <h2 className="text-xl font-semibold">Cart</h2>
      {cartItems?.map((item) => (
        <CartItem key={item.id} item={item} />
      ))}
    </div>
  );
};

export default CartList;
